module.exports = __webpack_public_path__ + "img/stamp-insect-jun.4232de4b.png";